import React, { useState, ChangeEvent, KeyboardEvent } from "react";
import FormGroup from "@mui/material/FormGroup";
import TextField from "@mui/material/TextField";
import TextFieldTracking from "../../../../Component/TextFieldTracking";
import Typography from "@mui/material/Typography";

interface Props {
    field: string;
    label: string;
    status: string | undefined;
    maxLength: number;
    multiline: boolean;
    trackingValue: number;
    value: string;
    handleChange: (
        event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
    ) => void;
    blurField: (
        event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
    ) => void;
    onKeyUp: (
        event: KeyboardEvent<HTMLInputElement | HTMLInputElement>
    ) => void;
    focusField: Function;
}

const QuizObjectTextField = ({
    blurField,
    focusField,
    handleChange,
    field,
    label,
    maxLength,
    multiline,
    trackingValue,
    status,
    onKeyUp,
    value,
}: Props) => {
    let [changed, setChanged] = useState(false);

    let localHandleChange = (e: any) => {
        handleChange(e);
    };

    let statusColor: "inherit" | "primary" | "secondary" | "textPrimary" | "textSecondary" | "initial" | "error" = "primary";
    if (status == "saved") statusColor = "primary";
    if (status == "changed") statusColor = "error";
    if (status == "error") statusColor = "error";
    if (status == "saving") statusColor = "secondary";

    // TODO: Make this accept max length field

    return (
        <FormGroup className="text-field">
            <TextField
                id={field}
                onChange={localHandleChange}
                value={value}
                multiline={multiline}
                onFocus={() => {
                    focusField(field);
                }}
                onBlur={blurField}
                onKeyUp={onKeyUp}
                className="form-control"
                label={label}
            />
        </FormGroup>
    );
};

export default QuizObjectTextField;
/* <TextFieldTracking number={trackingValue} /> */
